import * as storage from "../../utils/storage";
import {createConnection, getHostName} from "../wsrpc";
import {makeResponse} from "helpers/response";
import $ from "jquery";

let credits = storage.get('user');

let token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJSTklTIiwiYXVkIjoiaHR0cDpcL1wvcm5pcy5jb20iLCJpYXQiOjE2MDkyNTYyOTgsIm5iZiI6MTYwOTE2OTg5OCwiaW5mbyI6IntcInVzZXJcIjp7XCJ1dWlkXCI6XCIxMjQ2ZDFiOC0yYjM3LTExZWItYmY2Zi0wMjUyZTc4ZDkwZDlcIixcImxvZ2luXCI6XCJiYXNoa2F0b3ZhXCIsXCJjb21wb25lbnRcIjpcIm9wZXJhdG9yXCIsXCJpc19zeXN0ZW1cIjpmYWxzZSxcImlzX3N1cGVydmlzb3JcIjpmYWxzZSxcImlzX3NlbWlfY29uZmlybWVkXCI6ZmFsc2UsXCJpc19ub3RpZmljYXRlZFwiOmZhbHNlLFwiaW5mb1wiOnt9fX0ifQ.ko2FdInAWl9-JZyxOO7yFARvL_z9JsMdF4YjiaUr9rU';

if (!window.RNIS_SETTINGS) {
    $.ajax({
        dataType: 'json',
        url: `${window.location.origin}/static/settings/settings.json`,
        async: false,
        success: function(data){window.RNIS_SETTINGS = data}
    });
}

if (!window.RNIS_SETTINGS.CITY_MURMANSK && !window.RNIS_SETTINGS.CITY_OMSK) {
    token = '';
}

if (credits && credits.token) {
    token = credits.token;
}

export const rpc = createConnection(token);

export async function connect() {
    return rpc.connect();
}

export async function connectionLost(callback) {
    await rpc.onLost(callback)
}

export async function connectionEstablished(callback) {
    await rpc.onEstablished(callback)
}

export async function request(method, ...args) {
    const response = await makeResponse(() => {
        return rpc.request(method, ...args);
    });

    return response;
}

export async function postData(url = '', meta = {}, data = {}, token = null) {
    const basicUrl = (window.RNIS_SETTINGS.isHTTP) ? `http://${getHostName('ajax')}/request?` : `https://${getHostName('ajax')}/request?`;
    const response = await fetch(`${basicUrl}${url}`, {
        method: 'POST',
        body: JSON.stringify({ headers: {
        'meta': meta,
        'token': token,
    }, ...data })
    });
    return await response.json();
}



// WEBPACK FOOTER //
// ./src/helpers/api/session.js